import React from "react";

import { BadgeContainer, BadgeText } from "./styles";

const Badge = ({ children }) => (
    <BadgeContainer>
        <BadgeText>{children}</BadgeText>
    </BadgeContainer>
);

export default Badge;
